import { useCallback, useEffect } from 'react';
import throttle from 'lodash/throttle';
import { useEventCallback } from '../useEventCallback';
/**
 * provide a throttle method for throttle method
 * @param fn method for throttle
 * @param throttleTime throttle timeout value, default is  `200`ms
 * @param throttleSettings throttle setting object, more detail see `lodash`
 */
export var useThrottle = function (fn, throttleTime, throttleSettings) {
    if (throttleTime === void 0) { throttleTime = 200; }
    var memoFn = useEventCallback(fn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var throttleFn = useCallback(throttle(memoFn, throttleTime, throttleSettings), []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(function () { return function () { return throttleFn.cancel(); }; }, []);
    return throttleFn;
};
